import React from 'react';
import RenderError from '../../components/RenderError';

function AdditionalBasicInfoFields({
  two,
  unit,
  handleInputChange,
  equipmentType,
  formData,
  errors
}) {
  return (
    <>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor="typeOfOperation"
        >
          What type of operation will your propane-fueled water heater be used
          for? (e.g., cleaning stalls, cleaning equipment, sterilizing)
        </label>
        <input
          type="text"
          name="typeOfOperation"
          value={formData[unit].typeOfOperation}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].typeOfOperation}
          />
        )}
      </div>
      <div className="form__field form__field--required">
        <label className="form__label u--margin-right-20" htmlFor="waterAmount">
          How much water is used at the installation site per month (in
          gallons)?
        </label>
        <input
          type="number"
          name="waterAmount"
          value={formData[unit].waterAmount}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].waterAmount} />
        )}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20"
          htmlFor="percentWaterHeated"
        >
          What percentage of the water is typically heated?
        </label>
        <input
          type="number"
          name="percentWaterHeated"
          value={formData[unit].percentWaterHeated}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].percentWaterHeated}
          />
        )}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20"
          htmlFor="waterTemperature"
        >
          To what temperature (degrees Fahrenheit) do you heat the water at the
          site?
        </label>
        <input
          type="number"
          name="waterTemperature"
          value={formData[unit].waterTemperature}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].waterTemperature}
          />
        )}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20"
          htmlFor="weeksPerYear"
        >
          How many weeks per year does your site require water heating?
        </label>
        <input
          type="number"
          name="weeksPerYear"
          value={formData[unit].weeksPerYear}
          className="form__input form__input--lg"
          onChange={(event) => handleInputChange(event, two)}
        />
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError
            error={errors[`${equipmentType}_${unit}`].weeksPerYear}
          />
        )}
      </div>
      <div className="form__field form__field--required">
        <label
          className="form__label u--margin-right-20 u--margin-bottom-0"
          htmlFor="connectedToGrid"
        >
          Is this installation site connected to the electric grid?
        </label>
        {errors[`${equipmentType}_${unit}`] && (
          <RenderError error={errors[`${equipmentType}_${unit}`].fuelType} />
        )}
        {['Yes', 'No'].map((choice) => (
          <label className="form__radio" key={choice}>
            <input
              type="radio"
              name={`connectedToGrid${two ? '2' : '1'}`}
              value={choice}
              checked={
                two
                  ? formData.unitTwo.connectedToGrid2 === choice
                    ? 'checked'
                    : ''
                  : formData.unitOne.connectedToGrid1 === choice
                  ? 'checked'
                  : ''
              }
              onChange={(event) => handleInputChange(event, two)}
            />
            {choice}
          </label>
        ))}
      </div>
    </>
  );
}

export default AdditionalBasicInfoFields;
